<template>
  <div>
    <div v-show="middle12" class="product-middle2-item" v-for="(item, index) in chang" :key="index">
      <div v-if="index === 0 || index === 2">
        <img :src="item.path" alt />
        <div class="product-middle2-info fadeInUp animated" style="animation-delay:0.8s">
          <h4>{{ item.name }}</h4>
          <p>{{ item.detail }}</p>
        </div>
      </div>
      <div v-else>
        <div class="product-middle2-info fadeInDown animated" style="animation-delay:0.4s">
          <h4>{{ item.name }}</h4>
          <p>{{ item.detail }}</p>
        </div>
        <img :src="item.path" alt />
      </div>
    </div>
    <!-- <div class="product-middle2-item"></div>
    <div class="product-middle2-item">
      <img src="../../assets/image/home33.png" alt />
      <div class="product-middle2-info">
        <h4>01.业务经办强管控</h4>
        <p>操作行为全程记录监控，获取行为数据，分析和构建业务经办数据模型，实现事前监督、事中告警、事后追溯。</p>
      </div>
    </div>
    <div class="product-middle2-item">
      <div class="product-middle2-info">
        <h4>01.业务经办强管控</h4>
        <p>操作行为全程记录监控，获取行为数据，分析和构建业务经办数据模型，实现事前监督、事中告警、事后追溯。</p>
      </div>
      <img src="../../assets/image/home33.png" alt />
    </div>-->
  </div>
</template>
<script>
export default {
  props: ["chang", "middle12"],
};
</script>
<style lang="scss" scoped>
.product-middle2-item {
  display: inline-block;
  width: 300px;
  float: left;
  cursor: pointer;
  vertical-align: text-top;
  img {
    position: relative;
    display: block;
    width: 158px;
    height: 195px;
    margin: 0 auto;
    animation: cir 3s linear infinite alternate;
    -webkit-animation: cir 3s linear infinite alternate;
  }
  @keyframes cir {
    0% {
      top: 0px;
    }
    50% {
      top: -10px;
    }
    100% {
      top: 0px;
    }
  }
  .product-middle2-info {
    margin-top: 73px;
    h4 {
      font-size: 18px;
      font-weight: bold;
      color: rgba(6, 10, 34, 1);
    }
    p {
      margin-top: 17px;
      width: 270px;
      height: 56px;
      font-size: 14px;
      // font-family: PingFang SC;
      font-weight: 400;
      color: rgba(52, 52, 55, 1);
      line-height: 21px;
    }
  }
}
.product-middle2-item:nth-child(2n) {
  .product-middle2-info {
    margin-top: 0;
    margin-bottom: 69px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/chanjing.vue